<qe-environment-banner></qe-environment-banner>

<div class="app" [ngClass]="{'with-env-warning': !isProdEnvironment, 'with-route-buttons': showDevRoutes.value}">
	<section class="app__header">
		<qe-header></qe-header>
		<qe-progress-bar
			*ngIf="showProgressBar"
			[ngClass]="{'is--branded': (brandConfig$ | async)?.id?.toLowerCase() !== 'embrace'}">
			<qe-progress-bar-step [step]="1" label="Pet Info"></qe-progress-bar-step>
			<qe-progress-bar-step [step]="2" label="Select Plan"></qe-progress-bar-step>
			<qe-progress-bar-step [step]="3" label="Checkout"></qe-progress-bar-step>
		</qe-progress-bar>
	</section>
	<main class="app__content" [ngClass]="{'progress-bar-hidden': !showProgressBar}">
		<div
			class="app__header-warning"
			data-quat="value_maxPetsWarning"
			*ngIf="showMaxPetsWarning$ | async">
			<strong>You have the maximum amount of pets for a quote.</strong> If you need to add more pets, please call us at <strong class="app__header-phone-number">{{ formattedPhoneNumber }}</strong>.
		</div>
		<router-outlet></router-outlet>
	</main>
	<section class="app__footer">
		<qe-footer></qe-footer>
	</section>
</div>
<qe-modal-dialog></qe-modal-dialog>
<dialog #loadingDialog class="qe-loading-dialog" aria-live="polite" aria-modal="true">
	<epi-large-loader
		#epiLargeLoader
		class="app__loader m--large"
		[attr.loading-text]="(loadingText$ | async)"
	></epi-large-loader>
</dialog>
